import { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import toastService from "../../_services/toastService";
import SatAPI from "../../_services/sat";

const api = SatAPI();

function EditModal({ data = {}, hideModal }) {
  const [year, setYear] = useState(data.year || "");
  const [makeCurrent, setMakeCurrent] = useState(false);

  const onFormSubmit = async e => {
    e.preventDefault();
    try {
      if (data.id) {
        await api.updateAcademicYear(data.id, year);
        if (makeCurrent) await api.setCurrentAcademicYear(data.id);
      } else {
        const created = await api.createAcademicYear(year);
        if (makeCurrent) await api.setCurrentAcademicYear(created.id);
      }
      toastService.send({ title: "Success", message: "Academiejaar is opgeslagen" });
      hideModal();
    } catch (error) {
      toastService.send({ title: "Fout", message: `${error.message ?? error}` });
    }
  };

  return (
    <Modal show onHide={hideModal} backdrop="static" keyboard={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Academiejaar {data.id ? "bewerken" : "aanmaken"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onFormSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Academiejaar</Form.Label>
            <Form.Control
              type="text"
              required
              placeholder="2024-2025"
              value={year}
              onChange={e => setYear(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            {data.current_year ? (
              <Form.Text className="text-success">
                <i className="fas fa-check-circle" />&nbsp;Dit is het huidige academiejaar
              </Form.Text>
            ) : (
              <Form.Check
                type="checkbox"
                label="Instellen als huidig academiejaar"
                checked={makeCurrent}
                onChange={e => setMakeCurrent(e.target.checked)}
              />
            )}
          </Form.Group>
          <Button variant="primary" type="submit">
            {data.id ? (
              <span><i className="far fa-edit" />&nbsp;Bewerk</span>
            ) : (
              <span><i className="far fa-plus" />&nbsp;Aanmaken</span>
            )}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default EditModal;
